/**
 * @file selectBlock
 * @author cxtom(cxtom2008@gmail.com)
 */

export default function selectBlock(
    descriptor,
    loaderContext,
    query
) {

    // script
    if (query.type === 'style') {
        loaderContext.callback(
            null,
            descriptor.compiled.css
        );
        return;
    }

    // script
    if (query.type === 'script') {
        loaderContext.callback(
            null,
            descriptor.blocks.script.code
        );
        return;
    }

    // custom
    if (query.type === 'custom' && query.index != null) {
        const block = descriptor.customBlocks[query.index];
        loaderContext.callback(
            null,
            block.content
        );
        return;
    }
}
